import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { GetInstituteInformation } from '../../../Actions/StudentA';
import { BaseUrl } from '../../../Actions/Base';
import ActiveInstructors from "../Assets/ActiveInstructors.png"
import InVehicleCompleted from "../Assets/InVehicleCompleted.png"
import TrainingVehicles from "../Assets/TrainingVehicles.png"
import TrainingStudents from "../Assets/Trainingstudents.png"
import CompletedInveicleHours from "../Assets/CompletedInveicleHours.png"
import certificatesAndawards from "../Assets/certificatesAndawards.png"
import Licanses from "../Assets/Licanses.png"
import CompletedOthers from "../Assets/CompletedOthers.png"
import CoursesOffered from "../Assets/CoursesOffered.png"
import CrownImage from "../Assets/CrownImage.svg"
import MedalImage from "../Assets/MedalImage.svg"

const TrainingHoursAndStaffs = ({courses, awards, InstituteTrainingStats}) => {
    const formatWithLeadingZero = (num) => {
        let number = parseInt(num, 10) || 0; // Convert to number safely
        return number < 10 ? `0${number}` : `${number}`; // Add leading zero if single-digit
    };    
    
    // Extract values from InstituteTrainingStats
    const statsMap = InstituteTrainingStats.reduce((acc, stat) => {
        return { ...acc, ...stat };
    }, {});
    

    return (
        <>
             <div className='w-full flex justify-center items-center mt-[80px]'>
            <div className='w-[90%] flex flex-col gap-[20px]'>
                <p className='text-[30px] font-bold text-center lg:text-left'>Institute Stats</p>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-[40px] gap-y-[20px]  mt-[20px]'>
                    {[
                        { src: ActiveInstructors, text: "Active Instructors:", TotalNumbers: formatWithLeadingZero(statsMap.TotalInstructors) },
                        { src: InVehicleCompleted, text: "In-vehicle Completed hours:", TotalNumbers: formatWithLeadingZero(statsMap.TotalInVehicleHours) },
                        { src: TrainingVehicles, text: "Training vehicles available:", TotalNumbers: formatWithLeadingZero(statsMap.TotalTrainingVehicles) },
                        { src: TrainingStudents, text: "Students trained:", TotalNumbers: formatWithLeadingZero(statsMap.TotalTrainingStudents) },
                        { src: CoursesOffered, text: "Courses Offered:", TotalNumbers: formatWithLeadingZero(courses) },
                        { src: certificatesAndawards, text: "Certifications & Awards:", TotalNumbers: formatWithLeadingZero(awards && Array.isArray(awards) ? awards.length : "0") },
                    ].map((item, index) => (
                        <div key={index} className='flex items-center justify-between'>
                            <img className='w-[80px] h-[80px] object-contain' src={item.src} alt={item.text} />
                            <p className='text-[18px] text-[#2D2366] w-full leading-5 break-words text-start SemiBold'>{item.text}</p>
                            {parseInt(item.TotalNumbers, 10) <= 99 ? (
                            <div className='relative'>
                                <img className='w-[60px]' src={MedalImage} alt="CrownImage" />
                                <p className='absolute text-[18px] text-[#FFFFFF] top-[13px] left-[12px]'>{item.TotalNumbers}</p>
                            </div>
                            ) : (
                            <div className='relative'>
                                <img className='w-[50px]' src={CrownImage} alt="CrownImage" />
                                <p className='absolute text-[18px] text-[#A1A3EF] top-[15px] left-[10px]'>{item.TotalNumbers}</p>
                            </div> 
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
        {/* <div className='w-full flex justify-center items-center mt-[80px]'>
            <div className='w-[90%] flex flex-col gap-[20px]'>
                <p className='text-[30px] font-bold'>Training Hours & Staff</p>
                <div className='grid grid-cols-3'>
                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={ActiveInstructors} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>14 Active Instructors</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={InVehicleCompleted} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366] text-bold'>42 Completed in-vehicle hours</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={TrainingVehicles} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>8 Training vehicles available</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={TrainingStudents} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>120 Students completed training</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={CompletedInveicleHours} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>30 Completed in-class hours</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={certificatesAndawards} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>3 Certifications & Awards</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={Licanses} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>Class A,B,C,D,G,M Licenses offered</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={CompletedOthers} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>42 Completed Online/Other hours</p>
                    </div>

                    <div className='flex justify-center items-center gap-[0px]'>
                        <img className='w-[100px] h-[100px]' src={CoursesOffered} alt="ActiveInstructors" />
                        <p className='text-[18px] text-[#2D2366]'>42 Courses Offered</p>
                    </div>
                </div>
            </div>
        </div> */}
        </>

    )
}

export default TrainingHoursAndStaffs